import { css, styled } from 'mymoria-ui';
import React from 'react';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

const Transition = styled.header`
  .visible {
    transition: all 200ms ease-in;
  }

  .hidden {
    transition: all 200ms ease-out;
    transform: translate(0, -107%);
  }
`;

const TopBorder = styled.div(
  ({ theme: { colors } }) => css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.25rem;
    background-color: ${colors.primary};
    z-index: 1100;
  `,
);

const Header = () => (
  <Transition>
    <TopBorder />
    <HeaderMobile />
    <HeaderDesktop />
  </Transition>
);

export default Header;
